module.exports = __webpack_public_path__ + "img/sec4_04.dd23eb24.png";